import { ColumnOrderState } from "@tanstack/react-table";

import { DatatableColumn } from "../datatable-types";

export const resolveColumnOrderFromUrl = (
  urlParams: URLSearchParams,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: DatatableColumn<any>[],
): ColumnOrderState | undefined => {
  const columnOrder = urlParams.get("columnOrder");

  if (!columnOrder) {
    return undefined;
  }

  try {
    const parsedColumnOrder = JSON.parse(columnOrder) as ColumnOrderState;

    const filteredColumnOrder = parsedColumnOrder.flatMap((columnId) =>
      columns.some((column) => column.columnId === columnId) ? columnId : [],
    );

    return filteredColumnOrder;
  } catch (error) {
    console.error("Failed to parse columnOrder from URL:", error);
    return undefined;
  }
};

export const encodeColumnOrderToUrl = (
  urlParams: URLSearchParams,
  columnOrder: ColumnOrderState | undefined,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: DatatableColumn<any>[],
): URLSearchParams => {
  const updatedParams = new URLSearchParams(urlParams);

  if (columnOrder) {
    const validColumnOrder = columnOrder.filter((columnId) => columns.some((column) => column.columnId === columnId));

    updatedParams.set("columnOrder", JSON.stringify(validColumnOrder));
  } else {
    updatedParams.delete("columnOrder");
  }

  return updatedParams;
};
